module.exports = __webpack_public_path__ + "static/logo-global-alliance-cce9511a02c3e4bec6d09d372b27c49e.png";